var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobilityStationsbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 1018.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .mobilityStations_before_svg__cls-56,.mobilityStations_before_svg__cls-60,.mobilityStations_before_svg__cls-70,.mobilityStations_before_svg__cls-71,.mobilityStations_before_svg__cls-80{fill:#898989}.mobilityStations_before_svg__cls-10,.mobilityStations_before_svg__cls-3{fill:#343a50}.mobilityStations_before_svg__cls-5,.mobilityStations_before_svg__cls-87{fill:#89bb21}.mobilityStations_before_svg__cls-10,.mobilityStations_before_svg__cls-11,.mobilityStations_before_svg__cls-22,.mobilityStations_before_svg__cls-23,.mobilityStations_before_svg__cls-24,.mobilityStations_before_svg__cls-25,.mobilityStations_before_svg__cls-26,.mobilityStations_before_svg__cls-27,.mobilityStations_before_svg__cls-29,.mobilityStations_before_svg__cls-30,.mobilityStations_before_svg__cls-33,.mobilityStations_before_svg__cls-34,.mobilityStations_before_svg__cls-37,.mobilityStations_before_svg__cls-39,.mobilityStations_before_svg__cls-40,.mobilityStations_before_svg__cls-43,.mobilityStations_before_svg__cls-44,.mobilityStations_before_svg__cls-5,.mobilityStations_before_svg__cls-53,.mobilityStations_before_svg__cls-54,.mobilityStations_before_svg__cls-76,.mobilityStations_before_svg__cls-84{stroke:#343a50}.mobilityStations_before_svg__cls-10,.mobilityStations_before_svg__cls-11,.mobilityStations_before_svg__cls-22,.mobilityStations_before_svg__cls-23,.mobilityStations_before_svg__cls-24,.mobilityStations_before_svg__cls-26,.mobilityStations_before_svg__cls-27,.mobilityStations_before_svg__cls-29,.mobilityStations_before_svg__cls-30,.mobilityStations_before_svg__cls-33,.mobilityStations_before_svg__cls-34,.mobilityStations_before_svg__cls-37,.mobilityStations_before_svg__cls-38,.mobilityStations_before_svg__cls-39,.mobilityStations_before_svg__cls-40,.mobilityStations_before_svg__cls-43,.mobilityStations_before_svg__cls-44,.mobilityStations_before_svg__cls-45,.mobilityStations_before_svg__cls-5,.mobilityStations_before_svg__cls-51,.mobilityStations_before_svg__cls-53,.mobilityStations_before_svg__cls-54,.mobilityStations_before_svg__cls-55,.mobilityStations_before_svg__cls-56,.mobilityStations_before_svg__cls-60,.mobilityStations_before_svg__cls-62,.mobilityStations_before_svg__cls-66,.mobilityStations_before_svg__cls-67,.mobilityStations_before_svg__cls-69,.mobilityStations_before_svg__cls-70,.mobilityStations_before_svg__cls-71,.mobilityStations_before_svg__cls-72,.mobilityStations_before_svg__cls-74,.mobilityStations_before_svg__cls-75,.mobilityStations_before_svg__cls-76,.mobilityStations_before_svg__cls-77,.mobilityStations_before_svg__cls-78,.mobilityStations_before_svg__cls-80,.mobilityStations_before_svg__cls-84{stroke-miterlimit:10}.mobilityStations_before_svg__cls-11,.mobilityStations_before_svg__cls-22,.mobilityStations_before_svg__cls-23,.mobilityStations_before_svg__cls-24,.mobilityStations_before_svg__cls-25,.mobilityStations_before_svg__cls-26,.mobilityStations_before_svg__cls-27,.mobilityStations_before_svg__cls-29,.mobilityStations_before_svg__cls-30,.mobilityStations_before_svg__cls-33,.mobilityStations_before_svg__cls-34,.mobilityStations_before_svg__cls-43,.mobilityStations_before_svg__cls-44,.mobilityStations_before_svg__cls-5,.mobilityStations_before_svg__cls-54,.mobilityStations_before_svg__cls-70,.mobilityStations_before_svg__cls-72,.mobilityStations_before_svg__cls-75{stroke-width:2px}.mobilityStations_before_svg__cls-6,.mobilityStations_before_svg__cls-9{fill:#dedede}.mobilityStations_before_svg__cls-6,.mobilityStations_before_svg__cls-8{mix-blend-mode:multiply}.mobilityStations_before_svg__cls-7{fill:#6b472d}.mobilityStations_before_svg__cls-10{stroke-width:.6px}.mobilityStations_before_svg__cls-11{fill:#468cbe}.mobilityStations_before_svg__cls-12{font-size:41.22px}.mobilityStations_before_svg__cls-12,.mobilityStations_before_svg__cls-13,.mobilityStations_before_svg__cls-28,.mobilityStations_before_svg__cls-30,.mobilityStations_before_svg__cls-40,.mobilityStations_before_svg__cls-42{fill:#fff}.mobilityStations_before_svg__cls-12,.mobilityStations_before_svg__cls-13{font-family:Lato-Regular,Lato}.mobilityStations_before_svg__cls-13{font-size:15.03px}.mobilityStations_before_svg__cls-14{letter-spacing:-.01em}.mobilityStations_before_svg__cls-15,.mobilityStations_before_svg__cls-16{letter-spacing:0}.mobilityStations_before_svg__cls-22{fill:#4a998a}.mobilityStations_before_svg__cls-23{fill:#525254}.mobilityStations_before_svg__cls-24{fill:#404040}.mobilityStations_before_svg__cls-25,.mobilityStations_before_svg__cls-53,.mobilityStations_before_svg__cls-54{fill:#46bea9}.mobilityStations_before_svg__cls-25{stroke-linecap:round;stroke-linejoin:round}.mobilityStations_before_svg__cls-26,.mobilityStations_before_svg__cls-38,.mobilityStations_before_svg__cls-45,.mobilityStations_before_svg__cls-51,.mobilityStations_before_svg__cls-67,.mobilityStations_before_svg__cls-78{fill:none}.mobilityStations_before_svg__cls-27{fill:#a8a9ad}.mobilityStations_before_svg__cls-28{opacity:.17}.mobilityStations_before_svg__cls-29{fill:#ef6767}.mobilityStations_before_svg__cls-33{fill:#0b0b0b}.mobilityStations_before_svg__cls-34{fill:#f57500}.mobilityStations_before_svg__cls-39,.mobilityStations_before_svg__cls-43{fill:#191919}.mobilityStations_before_svg__cls-37,.mobilityStations_before_svg__cls-44{fill:#857d7a}.mobilityStations_before_svg__cls-37,.mobilityStations_before_svg__cls-40{stroke-width:.45px}.mobilityStations_before_svg__cls-38,.mobilityStations_before_svg__cls-45,.mobilityStations_before_svg__cls-51{stroke:#191919}.mobilityStations_before_svg__cls-38{stroke-width:.9px}.mobilityStations_before_svg__cls-39{stroke-width:.21px}.mobilityStations_before_svg__cls-45{stroke-width:4.36px}.mobilityStations_before_svg__cls-50{fill:#adadad}.mobilityStations_before_svg__cls-51{stroke-width:4.71px}.mobilityStations_before_svg__cls-53{stroke-width:1.85px}.mobilityStations_before_svg__cls-55,.mobilityStations_before_svg__cls-57,.mobilityStations_before_svg__cls-69{fill:#2c3d51}.mobilityStations_before_svg__cls-55,.mobilityStations_before_svg__cls-56,.mobilityStations_before_svg__cls-60,.mobilityStations_before_svg__cls-62,.mobilityStations_before_svg__cls-66,.mobilityStations_before_svg__cls-67,.mobilityStations_before_svg__cls-69,.mobilityStations_before_svg__cls-70,.mobilityStations_before_svg__cls-71,.mobilityStations_before_svg__cls-72,.mobilityStations_before_svg__cls-74,.mobilityStations_before_svg__cls-75,.mobilityStations_before_svg__cls-77,.mobilityStations_before_svg__cls-78,.mobilityStations_before_svg__cls-80{stroke:#2c3d4f}.mobilityStations_before_svg__cls-55,.mobilityStations_before_svg__cls-60,.mobilityStations_before_svg__cls-62,.mobilityStations_before_svg__cls-66{stroke-width:.19px}.mobilityStations_before_svg__cls-56{stroke-width:.34px}.mobilityStations_before_svg__cls-72{fill:#455064}.mobilityStations_before_svg__cls-62,.mobilityStations_before_svg__cls-74,.mobilityStations_before_svg__cls-76{fill:#2d3e50}.mobilityStations_before_svg__cls-75{fill:#aec2dd}.mobilityStations_before_svg__cls-66,.mobilityStations_before_svg__cls-77{fill:#2c3d4f}.mobilityStations_before_svg__cls-67{stroke-width:.5px}.mobilityStations_before_svg__cls-69,.mobilityStations_before_svg__cls-74,.mobilityStations_before_svg__cls-76,.mobilityStations_before_svg__cls-77,.mobilityStations_before_svg__cls-80{stroke-width:1.03px}.mobilityStations_before_svg__cls-71{stroke-width:1.85px}.mobilityStations_before_svg__cls-78{stroke-width:2.75px}.mobilityStations_before_svg__cls-84{stroke-width:3.34px;fill:#464655}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Mobitit\\xE4tsstation_Nachher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Boden"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-1 1019.72 -.97 808.81 -1 258.61 1258.98 258.61 1258.98 1019.72 0 1019.72 -1 1019.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 259.61v759.11H0V259.61h1258m2-2H-2v763.11h1262V257.61z",
    className: "mobilityStations_before_svg__cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Wiese"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#a9bf5c",
    points: "-1.16 369.32 -1.16 -62.44 1260.13 -62.44 1259.14 369.32 -1.16 369.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259-61.28l-1 429.43H0V-61.28h1259m2.33-2.32H-2.33v434.08H1260.3v-2.32l1-429.43v-2.33z",
    className: "mobilityStations_before_svg__cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 996.82,
    cy: 45.1,
    className: "mobilityStations_before_svg__cls-5",
    rx: 90.06,
    ry: 90.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.25 46.84c0-50.14 40.32-90.78 90.06-90.78 2.06 0 4.1.08 6.13.22a89.32 89.32 0 00-18.62-2c-49.74 0-90.06 40.64-90.06 90.77 0 48.06 37 87.38 83.93 90.56a90.63 90.63 0 01-71.44-88.77z",
    className: "mobilityStations_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.81 311a4.57 4.57 0 01-3.3-1.4 4.38 4.38 0 01-1.22-3.27l14.37-211-16.26-16.48a1.51 1.51 0 01-.33-1.67 1.53 1.53 0 011.41-1 1.65 1.65 0 01.68.16l15.28 7.46 2.14-31.35.13-2.51a4.34 4.34 0 018.66-.16l1.43 19.59 15.18-8.1h.16a2.81 2.81 0 01.49 0 2.68 2.68 0 011.58 4.8l-16 11.65 14.44 228.48a4.45 4.45 0 01-1.15 3.35 4.58 4.58 0 01-3.36 1.46z",
    className: "mobilityStations_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.05 46.84a3.24 3.24 0 013.33 3.07l1.53 21.09 16.4-8.75h.32a1.68 1.68 0 011 3l-16.43 12 14.47 229a3.48 3.48 0 01-3.51 3.75h-34.35a3.49 3.49 0 01-3.52-3.62l14.4-211.48-16.58-16.75a.55.55 0 01.37-.93.53.53 0 01.24.06l16.62 8.11 2.23-32.84.13-2.55a3.24 3.24 0 013.35-3.19m0-2a5.24 5.24 0 00-5.34 5.09l-.13 2.52-2 29.84-13.98-6.78a2.59 2.59 0 00-1.12-.26 2.55 2.55 0 00-1.79 4.34l15.94 16.1-14.33 210.56a5.42 5.42 0 001.48 4 5.59 5.59 0 004 1.71h34.33a5.58 5.58 0 004.1-1.79 5.46 5.46 0 001.4-4.13l-14.4-227.88 15.54-11.32a3.67 3.67 0 00-2.15-6.62 3.79 3.79 0 00-.67.06l-.31.06-.28.15-13.68 7.29-1.32-18a5.27 5.27 0 00-5.32-4.93z",
    className: "mobilityStations_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "mobilityStations_before_svg__cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007 72.76l18-9.62a1.63 1.63 0 00-1.76-.87L1006.91 71zM999.63 87l2.37-34.45.13-2.52a3.2 3.2 0 011.65-2.76 3.35 3.35 0 00-5 2.76l-.13 2.52-2.22 32.84zM984.69 306.36L999.08 94.9l-15.64-15.8-3.72-1.82a.54.54 0 00-.61.87l16.58 16.75-14.4 211.46a3.49 3.49 0 003.52 3.62h3.39a3.48 3.48 0 01-3.51-3.62z",
    className: "mobilityStations_before_svg__cls-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Baum-2",
    "data-name": "Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 913.66,
    cy: 125.9,
    className: "mobilityStations_before_svg__cls-5",
    rx: 63.16,
    ry: 63.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.26 127.12c0-35.16 28.28-63.66 63.17-63.66q2.16 0 4.29.15a62.42 62.42 0 00-13.06-1.37c-34.88 0-63.16 28.5-63.16 63.66 0 33.71 26 61.29 58.87 63.51a63.55 63.55 0 01-50.11-62.29z",
    className: "mobilityStations_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.24 312.67a3.51 3.51 0 01-2.53-1.08 3.34 3.34 0 01-.93-2.51l10.07-147.87-11.31-11.43a1.36 1.36 0 01-.3-1.49 1.36 1.36 0 011.87-.72l10.32 5 1.47-21.55.09-1.75a3.34 3.34 0 016.67-.12l1 13.28 10.26-5.43h.15a1.87 1.87 0 01.4 0 2.18 2.18 0 011.29 3.91l-11.09 8.07L932.78 309a3.42 3.42 0 01-.88 2.57 3.53 3.53 0 01-2.58 1.12z",
    className: "mobilityStations_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.34 127.12a2.27 2.27 0 012.33 2.16l1.08 14.8 11.5-6.14h.22a1.18 1.18 0 01.68 2.11l-11.52 8.39L931.78 309a2.43 2.43 0 01-2.46 2.63h-24.08a2.43 2.43 0 01-2.46-2.54l10.1-148.3-11.63-11.75a.38.38 0 01.26-.65.32.32 0 01.16 0l11.66 5.69 1.57-23 .09-1.77a2.27 2.27 0 012.35-2.24m0-2a4.25 4.25 0 00-4.35 4.14l-.09 1.79-1.36 20-9-4.39a2.38 2.38 0 00-2.72 3.82l11 11.1L900.78 309a4.39 4.39 0 001.21 3.28 4.49 4.49 0 003.25 1.39h24.08a4.49 4.49 0 003.31-1.45 4.36 4.36 0 001.14-3.35L923.7 149.39l10.63-7.74a3.18 3.18 0 00-1.86-5.73 3.66 3.66 0 00-.57.05l-.31.06-.28.15-8.79 4.69-.86-11.74a4.27 4.27 0 00-4.32-4z",
    className: "mobilityStations_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "mobilityStations_before_svg__cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M920.84 145.3l12.64-6.74a1.13 1.13 0 00-1.23-.62l-11.5 6.14zM915.64 155.28l1.64-24.15.09-1.77a2.26 2.26 0 011.15-1.94 2.35 2.35 0 00-3.53 1.94l-.09 1.77-1.56 23zM905.16 309.13l10.1-148.3-11-11.08-2.61-1.28a.38.38 0 00-.42.61l11.63 11.75-10.1 148.3a2.43 2.43 0 002.46 2.54h2.38a2.43 2.43 0 01-2.44-2.54z",
    className: "mobilityStations_before_svg__cls-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Baum-3",
    "data-name": "Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.2,
    cy: -42.81,
    className: "mobilityStations_before_svg__cls-5",
    rx: 90.95,
    ry: 91.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.53-41.06c0-50.63-40.72-91.67-90.95-91.67-2.08 0-4.14.08-6.19.22a90.39 90.39 0 0118.81-2c50.23 0 90.95 41 90.95 91.67 0 48.53-37.42 88.24-84.76 91.45a91.52 91.52 0 0072.14-89.67z",
    className: "mobilityStations_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.65 225.68a4.6 4.6 0 01-3.38-1.48 4.45 4.45 0 01-1.15-3.39L417.69-9.91l-16.14-11.75a2.65 2.65 0 01-.93-3 2.62 2.62 0 012.5-1.83 2.89 2.89 0 01.5 0h.15l15.35 8.18L420.56-38a4.27 4.27 0 014.35-4 4.29 4.29 0 014.38 4.18l.13 2.54 2.16 31.66L447-11.21a1.45 1.45 0 01.68-.16 1.52 1.52 0 011.41 1 1.49 1.49 0 01-.33 1.67l-16.4 16.56L446.88 221a4.42 4.42 0 01-1.23 3.3 4.58 4.58 0 01-3.32 1.42z",
    className: "mobilityStations_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.91-41.06a3.28 3.28 0 013.38 3.23l.13 2.54 2.26 33.16 16.78-8.18a.61.61 0 01.25-.06.54.54 0 01.37.93L431.34 7.47 445.88 221a3.51 3.51 0 01-3.55 3.66h-34.68a3.51 3.51 0 01-3.54-3.78l14.62-231.27-16.59-12.08a1.69 1.69 0 011-3 1.73 1.73 0 01.32 0L420-16.64 421.56-38a3.27 3.27 0 013.35-3.1m0-2a5.3 5.3 0 00-5.35 4.93l-1.33 18.28-13.85-7.39-.28-.15-.31-.05a3.79 3.79 0 00-.67-.06 3.67 3.67 0 00-3.45 2.54 3.63 3.63 0 001.25 4.11l15.74 11.47-14.54 230.19a5.44 5.44 0 001.41 4.11 5.61 5.61 0 004.12 1.8h34.68a5.63 5.63 0 004.05-1.73 5.42 5.42 0 001.5-4L433.39 8.24 449.5-8a2.54 2.54 0 00.55-2.77 2.55 2.55 0 00-2.34-1.57 2.56 2.56 0 00-1.12.26l-14.11 6.85-2.06-30.19-.13-2.51a5.27 5.27 0 00-5.38-5.13z",
    className: "mobilityStations_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "mobilityStations_before_svg__cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.45 221L427.91 7.47l15.8-15.95 3.75-1.83a.54.54 0 01.62.87L431.34 7.47 445.88 221a3.51 3.51 0 01-3.55 3.66h-3.43a3.51 3.51 0 003.55-3.66z",
    className: "mobilityStations_before_svg__cls-9"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "mobilityStations_before_svg__Schild1",
    width: 2.8,
    height: 63.23,
    x: 319.1,
    y: 329.56,
    className: "mobilityStations_before_svg__cls-10"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mobilityStations_before_svg__Schild1-2",
    width: 2.8,
    height: 63.23,
    x: 572.86,
    y: 329.22,
    className: "mobilityStations_before_svg__cls-10",
    "data-name": "Schild1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Schild1-3",
    "data-name": "Schild1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.92,
    height: 62.56,
    x: 530.8,
    y: 267,
    className: "mobilityStations_before_svg__cls-11",
    rx: 13.38
  }), /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_before_svg__cls-12",
    transform: "matrix(1.04 0 0 1 563.23 304.96)"
  }, "\r\n      P\r\n     "), /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_before_svg__cls-13",
    transform: "matrix(1.04 0 0 1 538.83 322.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "mobilityStations_before_svg__cls-14"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.61,
    y: 0,
    className: "mobilityStations_before_svg__cls-15"
  }, "arSha"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.78,
    y: 0,
    className: "mobilityStations_before_svg__cls-16"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.75,
    y: 0
  }, "ing"))), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Schild1-4",
    "data-name": "Schild1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 63.23,
    x: 826.59,
    y: 329.56,
    className: "mobilityStations_before_svg__cls-10"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.42,
    height: 62.56,
    x: 800.24,
    y: 267,
    fill: "#065494",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.45,
    rx: 10.69
  }), /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_before_svg__cls-12",
    transform: "matrix(1.04 0 0 1 816.62 301.41)"
  }, "\r\n      P\r\n     "), /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_before_svg__cls-13",
    transform: "matrix(1.04 0 0 1 809.53 322.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-.02em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.76,
    y: 0,
    letterSpacing: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.73,
    y: 0,
    letterSpacing: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.25,
    y: 0,
    letterSpacing: 0
  }, "va"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.61,
    y: 0
  }, "t"))), /*#__PURE__*/React.createElement("rect", {
    id: "mobilityStations_before_svg__Schild1-5",
    width: 2.8,
    height: 63.23,
    x: 1080.33,
    y: 329.56,
    className: "mobilityStations_before_svg__cls-10",
    "data-name": "Schild1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1129.68 382.63l19.41-9.38-16.17-15.25c-.34.16-23.53-4.46-23.87-4.3a15.68 15.68 0 00-2.3 1.36l-57.51-1.36-5.9 2.13c-.45-.21-1.35 1.37-1.8 1.15s-.23 1.66-.57 1.49l-17.68 16.64 20.26 10.21c4.91-7.15 11.16-12.07 25-10.84h28.21c15.1.2 27.24 3.66 32.92 8.15z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.63 373.55H1070c-18.73 0-33.91 10.69-33.91 23.88l-17 3h137.41l-19-3c.05-13.19-15.14-23.88-33.87-23.88zm30.08 23.37H1040v-.46c0-11.68 13.45-21.15 30-21.15h33.59c16.6 0 30 9.47 30 21.15z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.53,
    height: 13.36,
    x: 1059.56,
    y: 391.71,
    className: "mobilityStations_before_svg__cls-23",
    transform: "rotate(-29.97 1061.014 398.424)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.36,
    height: 2.53,
    x: 1065.22,
    y: 397.13,
    className: "mobilityStations_before_svg__cls-23",
    transform: "rotate(-60.02 1071.927 398.393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.74 425.84a19.13 19.13 0 1119.12-19.13 19.15 19.15 0 01-19.12 19.13zm0-34.46a15.33 15.33 0 1015.33 15.33 15.34 15.34 0 00-15.33-15.33z",
    className: "mobilityStations_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.44,
    height: 25.98,
    x: 985.4,
    y: 487.18,
    className: "mobilityStations_before_svg__cls-24",
    rx: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.44,
    height: 25.98,
    x: 1154.99,
    y: 487.18,
    className: "mobilityStations_before_svg__cls-24",
    rx: 5.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.76 397.27a12.65 12.65 0 00-5.45-4.88s-6-3.35-17.66-1.15a3 3 0 00-1.58.72c-1.68 1.52-.86 4.87-.72 5.45 1 3.94 4.17 6.24 6.46 7.9a23.14 23.14 0 006.75 3.3 14.43 14.43 0 005.89.86c1.43-.14 5.07-.5 6.89-3.3 2.3-3.55-.17-8.17-.58-8.9zM1160.09 398.5a12.72 12.72 0 015.45-4.88s6-3.34 17.66-1.15a3.15 3.15 0 011.58.72c1.68 1.53.86 4.88.72 5.46-1 3.93-4.16 6.24-6.46 7.89a22.63 22.63 0 01-6.75 3.3 14.26 14.26 0 01-5.89.87c-1.43-.14-5.07-.5-6.89-3.31-2.3-3.55.17-8.17.58-8.9z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.87 405.56c0-2.39-34.12-4.32-76.21-4.32s-76.2 1.93-76.2 4.32l-31.65 18.51 215-.48z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.49 424.53c-8-5.67-53.78-10-109.07-10-58.39 0-106.18 4.85-110.06 11a11.5 11.5 0 00-5.09 9.56v29.4c1.52 5.7 52.65 10.29 115.5 10.29s114-4.59 115.5-10.29v-29.4a11.53 11.53 0 00-6.78-10.56z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1085.87,
    x2: 1085.86,
    y1: 370.15,
    y2: 378.11,
    className: "mobilityStations_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.28 464.78a5.06 5.06 0 00-1.94-4v3.66c-1.51 5.7-52.64 10.29-115.5 10.29s-114-4.59-115.5-10.29v-3.64a5.06 5.06 0 00-1.93 4v17.66a4.82 4.82 0 00.16 1.2 1.51 1.51 0 00-.16.64c0 7 52.6 12.59 117.47 12.59s117.47-5.64 117.47-12.59a1.5 1.5 0 00-.15-.64 4.81 4.81 0 00.15-1.2z",
    className: "mobilityStations_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.91,
    height: 5.83,
    x: 1074.91,
    y: 375.19,
    className: "mobilityStations_before_svg__cls-23",
    rx: 2.15
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1013.97 402.17 1158.41 404.3 1154.42 379.89 1139.68 363.92 1127.49 355.74 1099.16 353.63 1044 356.49 1029.86 366.07 1017.6 383.6 1013.97 402.17",
    className: "mobilityStations_before_svg__cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.57 351.4H1063a50.07 50.07 0 00-50.07 50.07v3.25h149.76v-3.25a50.07 50.07 0 00-50.12-50.07zm44.39 49h-138.29v-1a44.35 44.35 0 0144.33-44.31h49.59a44.35 44.35 0 0144.41 44.35z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.91,
    height: 15.59,
    x: 975.72,
    y: 429.87,
    className: "mobilityStations_before_svg__cls-29",
    rx: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.91,
    height: 15.59,
    x: 1170.23,
    y: 429.66,
    className: "mobilityStations_before_svg__cls-29",
    rx: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.17,
    height: 16.17,
    x: 1054.21,
    y: 451.08,
    className: "mobilityStations_before_svg__cls-30",
    rx: 6.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Auto-2",
    "data-name": "Auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.53 376.19l19.41-9.38-16.17-15.22c-.34.16-23.53-4.46-23.87-4.3a16.62 16.62 0 00-2.3 1.36l-57.51-1.36-5.9 2.13c-.45-.21-1.35 1.37-1.8 1.15s-.23 1.66-.57 1.49l-17.68 16.64 20.25 10.21c4.92-7.15 11.16-12.07 25-10.84h28.21c15.11.17 27.26 3.63 32.93 8.12z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.48 367.12h-33.61C539.14 367.12 524 377.8 524 391l-17 3h137.35l-19-3c.05-13.2-15.14-23.88-33.87-23.88zm30.07 23.36h-93.68V390c0-11.68 13.45-21.14 30-21.14h33.59c16.59 0 30 9.46 30 21.14z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.53,
    height: 13.36,
    x: 547.41,
    y: 385.28,
    className: "mobilityStations_before_svg__cls-23",
    transform: "rotate(-29.97 548.77 391.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.36,
    height: 2.53,
    x: 553.07,
    y: 390.69,
    className: "mobilityStations_before_svg__cls-23",
    transform: "rotate(-60.02 559.77 391.958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.58 419.4a19.13 19.13 0 1119.13-19.13 19.15 19.15 0 01-19.13 19.13zm0-34.46a15.34 15.34 0 1015.34 15.33 15.35 15.35 0 00-15.34-15.33z",
    className: "mobilityStations_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.44,
    height: 25.98,
    x: 473.25,
    y: 480.74,
    className: "mobilityStations_before_svg__cls-24",
    rx: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.44,
    height: 25.98,
    x: 642.84,
    y: 480.74,
    className: "mobilityStations_before_svg__cls-24",
    rx: 5.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.61 390.83a12.65 12.65 0 00-5.45-4.88s-6-3.35-17.66-1.15a3.06 3.06 0 00-1.58.72c-1.68 1.52-.86 4.87-.72 5.45 1 3.94 4.16 6.25 6.46 7.9a23.14 23.14 0 006.75 3.3 14.21 14.21 0 005.88.86c1.44-.14 5.08-.5 6.89-3.3 2.31-3.55-.18-8.17-.57-8.9zM647.94 392.06a12.72 12.72 0 015.45-4.88s6-3.34 17.66-1.15a3.22 3.22 0 011.58.72c1.68 1.53.86 4.88.72 5.46-1 3.93-4.17 6.24-6.46 7.89a22.82 22.82 0 01-6.75 3.31 14.43 14.43 0 01-5.89.86c-1.43-.14-5.07-.5-6.89-3.3-2.3-3.56.17-8.18.58-8.91z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.72 399.12c0-2.39-34.12-4.32-76.21-4.32s-76.2 1.93-76.2 4.32l-31.84 18.23 216.16.3z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.34 418.09c-8-5.67-53.78-10-109.08-10-58.39 0-106.17 4.85-110 11a11.52 11.52 0 00-5.1 9.56V458c1.51 5.7 52.64 10.29 115.5 10.29s114-4.59 115.5-10.29v-29.4a11.53 11.53 0 00-6.82-10.51z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.72,
    x2: 573.71,
    y1: 363.71,
    y2: 371.67,
    className: "mobilityStations_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.13 458.34a5.06 5.06 0 00-1.94-4V458c-1.51 5.7-52.64 10.29-115.5 10.29s-114-4.59-115.5-10.29v-3.64a5.08 5.08 0 00-1.92 4V476a5.33 5.33 0 00.15 1.2 1.5 1.5 0 00-.15.64c0 7 52.6 12.59 117.47 12.59s117.47-5.64 117.47-12.59a1.5 1.5 0 00-.15-.64 4.81 4.81 0 00.15-1.2z",
    className: "mobilityStations_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.91,
    height: 5.83,
    x: 562.76,
    y: 368.75,
    className: "mobilityStations_before_svg__cls-23",
    rx: 2.15
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.64 395.54 645.08 397.67 641.09 373.26 626.35 357.3 614.16 349.11 585.83 347.01 530.67 349.86 516.52 359.45 504.27 376.98 500.64 395.54",
    className: "mobilityStations_before_svg__cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.42 345H550.8a50.07 50.07 0 00-50.07 50v3.26h149.75V395a50.07 50.07 0 00-50.06-50zm44.39 49h-138.3v-1a44.35 44.35 0 0144.35-44.35h49.6A44.35 44.35 0 01644.81 393z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.91,
    height: 15.59,
    x: 463.56,
    y: 423.43,
    className: "mobilityStations_before_svg__cls-29",
    rx: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.91,
    height: 15.59,
    x: 658.08,
    y: 423.23,
    className: "mobilityStations_before_svg__cls-29",
    rx: 5.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.17,
    height: 16.17,
    x: 542.18,
    y: 444.64,
    className: "mobilityStations_before_svg__cls-30",
    rx: 6.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Autos"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M936.63 449.41H722.16L737 257.3a22.36 22.36 0 0122.36-22.36h140.12a22.36 22.36 0 0122.36 22.36z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.93,
    height: 48.09,
    x: 899.28,
    y: 464.08,
    className: "mobilityStations_before_svg__cls-24",
    rx: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.93,
    height: 48.09,
    x: 732.58,
    y: 464.08,
    className: "mobilityStations_before_svg__cls-24",
    rx: 6.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.39 241.19h66.12a19 19 0 0119 19v189.22h-85.12V241.19z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.28 241.19h85.11v189.23a19 19 0 01-19 19h-66.11V241.19z",
    className: "mobilityStations_before_svg__cls-22",
    transform: "rotate(-180 786.84 345.305)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343432",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M722.16 449.41h214.47v11.3a18 18 0 01-18 18H740.19a18 18 0 01-18-18v-11.3h-.03z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 177.44,
    height: 17.79,
    x: 740.92,
    y: 449.41,
    fill: "#21211e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.49 376.26h-3.77a5.3 5.3 0 00-9.18 0h-6.77a2.17 2.17 0 000 4.33h6.29a5.31 5.31 0 0010.14 0h3.29a2.17 2.17 0 000-4.33zM864.5 376.26h-6.77a5.3 5.3 0 00-9.18 0h-3.77a2.17 2.17 0 000 4.33h3.29a5.31 5.31 0 0010.14 0h6.29a2.17 2.17 0 000-4.33z",
    className: "mobilityStations_before_svg__cls-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.68 427a4.37 4.37 0 004.35-4.36v-42a4.37 4.37 0 00-4.35-4.36h-7.89l-3.9 50.72zM922.49 427a4.37 4.37 0 01-4.35-4.36v-42a4.37 4.37 0 014.35-4.36h7.89l3.9 50.71z",
    className: "mobilityStations_before_svg__cls-34"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.67,
    height: 12.5,
    x: 842.38,
    y: 424.89,
    fill: "#e6e6e6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    rx: 5.95
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Station_Fahrr\\xE4der"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1225.47 511.88a60.61 60.61 0 00-121.22 0c0 .91 0 1.81.07 2.7h-.07V837h121.22V514.58h-.07c.04-.89.07-1.79.07-2.7z",
    className: "mobilityStations_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Icon_Fahrrad"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.35,
    height: 1.5,
    x: 1164.73,
    y: 515.93,
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 0.16,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1162.57 523.69 1161.73 522.94 1166.49 516.68 1167.64 516.67 1162.57 523.69",
    className: "mobilityStations_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1138.01 523.87 1128.4 514.47 1129.44 513.51 1139.05 522.91 1138.01 523.87",
    className: "mobilityStations_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.87,
    cy: 524.24,
    r: 4.32,
    className: "mobilityStations_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166 523c.3 1.24-.14 5.6-4.08 5.53-2 0-25.22-1.62-24.46-5.53.54-2.76 16.27-3.11 24.46-3.11-.02.03 3.3.03 4.08 3.11z",
    className: "mobilityStations_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.9 537.28a14.32 14.32 0 1114.32-14.28 14.33 14.33 0 01-14.32 14.28zm0-27.26a12.95 12.95 0 1012.95 12.98 13 13 0 00-12.95-13z",
    className: "mobilityStations_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1190.48 522.79 1184.81 510.61 1186.12 510.07 1191.79 522.26 1190.48 522.79",
    className: "mobilityStations_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.89 538.53a15.57 15.57 0 1111-4.56 15.47 15.47 0 01-11 4.56zm0-29.78a14.22 14.22 0 1014.22 14.25 14.23 14.23 0 00-14.22-14.25zM1191.27 538.53a15.57 15.57 0 1111-4.56 15.47 15.47 0 01-11 4.56zm0-29.78a14.22 14.22 0 1014.22 14.25 14.22 14.22 0 00-14.22-14.25z",
    className: "mobilityStations_before_svg__cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.53 506.41a16.77 16.77 0 00-5.23-.82 17 17 0 00-7.1 1.54l-1.17-2.88a.67.67 0 00-.15-.66.7.7 0 00-.17-.13l-.71-1.76a.64.64 0 000-.45l-2.42-5.88a.68.68 0 10-1.25.52l2 5-24.41.92-1.52-5.35a.66.66 0 00-.83-.46.67.67 0 00-.47.83l1.57 5.52-5.4 6.84a17 17 0 00-22.56 1.45 17.19 17.19 0 00-5 12.18.85.85 0 00.85.85.84.84 0 00.84-.85 15.49 15.49 0 0115.42-15.53 15.22 15.22 0 019.4 3.24l-9.92 12.56a.68.68 0 00-.08.7.69.69 0 00.58.4l22 1.1h.37l21-20 1 2.49a17 17 0 00-4.06 3 17.19 17.19 0 00-5 12.18.85.85 0 101.69 0 15.49 15.49 0 0115.41-15.53 15.26 15.26 0 014.71.74.86.86 0 001.07-.55.84.84 0 00-.46-1.21zm-47.26 5a15.55 15.55 0 015 11.42.85.85 0 00.65.82l-14.7-.74zm5.94 12.26a.85.85 0 00.73-.84 17.19 17.19 0 00-5-12.18c-.19-.2-.4-.39-.6-.58l4.78-6 4.85 19.89zm6-.34l-4.92-20.17 24.78-.93.64 1.58z",
    className: "mobilityStations_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191.27,
    cy: 522.96,
    r: 1.35,
    className: "mobilityStations_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.39 537.12a14.32 14.32 0 1114.32-14.31 14.33 14.33 0 01-14.32 14.31zm0-27.26a12.95 12.95 0 1012.95 12.95 13 13 0 00-12.95-12.95z",
    className: "mobilityStations_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1152.43,
    cy: 494.66,
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 0.45,
    rx: 7.22,
    ry: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.1 484.14a8.3 8.3 0 00-.52 1.11l-2.7 9.32-7.21 5.56c-.49.35-1 .41-.6.9.21.3.2.29.54.29a1.1 1.1 0 00.64-.2l7-5.05 1 2.24 1.4-.59-1.34-3.14 2.56-9.09c.13-.58-1.2-.93-.77-1.35z",
    className: "mobilityStations_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1161.87,
    cy: 524.31,
    r: 1.35,
    className: "mobilityStations_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.29,
    height: 1.11,
    x: 1156.63,
    y: 527.04,
    className: "mobilityStations_before_svg__cls-37",
    transform: "rotate(-64.16 1160.336 527.583)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.81,
    height: 2,
    x: 1156.1,
    y: 530.15,
    className: "mobilityStations_before_svg__cls-39",
    rx: 0.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1179.94,
    x2: 1181.23,
    y1: 488.34,
    y2: 484.21,
    className: "mobilityStations_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.27 488.94l-1.66-.77.7-3.29c.14-.68.63-1.06 1.09-.84a1.44 1.44 0 01.57 1.6z",
    className: "mobilityStations_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1172.96,
    x2: 1170.67,
    y1: 498.64,
    y2: 500.73,
    className: "mobilityStations_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.84 498.05l.7 1.61-2.54 1.74c-.52.36-1.1.29-1.3-.15a1.31 1.31 0 01.6-1.45z",
    className: "mobilityStations_before_svg__cls-40"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1138.41 553.9h14.76v14.76h-14.76V553.9m-1.4-1.4v17.56h17.56V552.5z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.82,
    height: 6.82,
    x: 1142.39,
    y: 557.85,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.2 553.9h14.8v14.76h-14.8V553.9m-1.4-1.4v17.56h17.55V552.5z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.82,
    height: 6.82,
    x: 1180.25,
    y: 557.85,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.41 591.69h14.76v14.75h-14.76v-14.75m-1.4-1.4v17.56h17.56v-17.56z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 6.8,
    x: 1142.39,
    y: 595.66,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.2 591.69h14.8v14.76h-14.8v-14.76m-1.4-1.4v17.56h17.55v-17.56z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 6.8,
    x: 1180.17,
    y: 595.66,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156 571.46h17.42v17.43H1156v-17.43m-1.4-1.4v20.23h20.23v-20.23z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.82,
    height: 6.82,
    x: 1161.33,
    y: 576.78,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 6.8,
    x: 1161.29,
    y: 590.29,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.82,
    height: 6.82,
    x: 1161.33,
    y: 563.24,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.82,
    height: 6.82,
    x: 1147.77,
    y: 576.79,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 6.8,
    x: 1174.86,
    y: 576.77,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 6.8,
    x: 1142.39,
    y: 583.57,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.82,
    height: 6.82,
    x: 1142.39,
    y: 569.96,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 6.8,
    x: 1181.67,
    y: 583.58,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 6.8,
    x: 1181.67,
    y: 569.97,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 6.8,
    x: 1154.48,
    y: 597.09,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 6.8,
    x: 1168.09,
    y: 597.09,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.82,
    height: 6.82,
    x: 1154.51,
    y: 556.42,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.82,
    height: 6.82,
    x: 1168.14,
    y: 556.42,
    className: "mobilityStations_before_svg__cls-42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Fahrrad2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.13,
    height: 7.29,
    x: 1034.6,
    y: 747.34,
    className: "mobilityStations_before_svg__cls-43",
    rx: 3.02
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1024.11 784.97 1020 781.36 1043.14 751 1048.68 750.95 1024.11 784.97",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "904.94 785.85 858.31 740.26 863.34 735.61 909.97 781.2 904.94 785.85",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020.68,
    cy: 787.67,
    r: 20.96,
    className: "mobilityStations_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.63 781.8c1.47 6-.67 27.16-19.78 26.83-9.6-.17-122.4-7.88-118.71-26.83 2.61-13.41 79-15.09 118.71-15.09 0 0 16.09 0 19.78 15.09z",
    className: "mobilityStations_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.25 850.94a69.46 69.46 0 1169.46-69.46 69.54 69.54 0 01-69.46 69.46zm0-132.3a62.84 62.84 0 1062.83 62.84 62.91 62.91 0 00-62.83-62.84z",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1159.53 780.63 1132.01 721.5 1138.36 718.92 1165.88 778.05 1159.53 780.63",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.18 857a75.54 75.54 0 1153.42-22.13A75 75 0 01909.18 857zm0-144.53a69 69 0 1069 69 69.06 69.06 0 00-69-68.99z",
    className: "mobilityStations_before_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.01,
    d: "M1163.36 857a75.54 75.54 0 1153.42-22.13 75 75 0 01-53.42 22.13zm0-144.53a69 69 0 1069 69 69.06 69.06 0 00-69-68.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1163.36,
    cy: 781.47,
    r: 6.54,
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.79 700.3a85.61 85.61 0 00-60 3.48l-5.71-13.64a3.16 3.16 0 00-.76-3.14 3.56 3.56 0 00-.8-.6l-3.49-8.32a3.12 3.12 0 00-.09-2.17l-11.73-27.65a3.45 3.45 0 00-4.2-2 3.17 3.17 0 00-2 4.24l10 23.57L993 678.42l-7.34-25.13a3.42 3.42 0 00-3.94-2.43 3.2 3.2 0 00-2.45 4l7.61 26.14-26.32 32.38a84.84 84.84 0 00-110 6.87 80.09 80.09 0 00-24.42 57.54 4.14 4.14 0 003.73 4.12 4.09 4.09 0 004.52-4c0-40.56 45.92-13.58 87.36-13.58L907 779.22a3.12 3.12 0 00.2 4.19 3.42 3.42 0 002.32 1l107.08 5.23h.95l.22-.06h.11l.22-.08h.09l.23-.12a.2.2 0 01.08 0l.24-.17a1.64 1.64 0 00.25-.21l102.21-94.53 4.93 11.77a83.72 83.72 0 00-19.8 14.38 80.09 80.09 0 00-24.33 57.27 4.13 4.13 0 003.73 4.12 4.08 4.08 0 004.52-4c0-40.56 33.72-73.56 75.16-73.56a76.9 76.9 0 0123 3.49 4.15 4.15 0 005.3-2.94 4.1 4.1 0 00-2.92-4.7zm-230.35 23.56a72.66 72.66 0 0124.26 54.07c0 1.89 2.56 3.19 4.37 3.61l-72.9-3.22zm28.63 57.68c2-.26 3.88-1.58 3.88-3.61a80.15 80.15 0 00-24.42-57.67c-1-.94-1.94-1.85-2.94-2.74l23.32-28.68 23.64 94.16zm29.58-1.24l-24-95.54 120.85-4.38 3.12 7.46z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164 850.17a69.46 69.46 0 1169.46-69.46 69.54 69.54 0 01-69.46 69.46zm0-132.29a62.83 62.83 0 1062.83 62.83 62.9 62.9 0 00-62.83-62.83z",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.89 663.2a6.52 6.52 0 01-3.43-3.21c-1.08-2.39-.56-5.13-.12-7.39.35-1.84 1.39-7.26 5.27-10.61a11.42 11.42 0 016.37-2.57 16.41 16.41 0 0111 1.77c4.48 2.52 4.91 5.53 9.65 7.15a18.07 18.07 0 004.69.72c6.09.5 9.56-.94 16.42-.32 3.84.34 5 1 5.64 2.25 1.09 2.17.28 5.61-.86 7.71-2.12 3.91-6.09 4.5-10.29 5-7.12.82-10.74.73-21 1.33-3.09.19-3.44.27-6.73.44-5.82.28-11.25.34-16.61-2.27z",
    className: "mobilityStations_before_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.2 593.08c.42-.42-1.71 2.59-2.5 5.42l-13.12 45.2-35 27c-2.39 1.71-4.63 2-2.92 4.37 1 1.45 1 1.42 2.63 1.42a5.35 5.35 0 003.1-1l34.15-24.49 4.63 10.88L1113 659l-6.47-15.2 12.39-44.12c.75-2.87-5.82-4.54-3.72-6.6z",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020.68,
    cy: 788,
    r: 6.54,
    fill: "#857d7a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.19
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.4,
    height: 5.37,
    x: 995.27,
    y: 801.25,
    className: "mobilityStations_before_svg__cls-44",
    transform: "rotate(-64.16 1013.03 803.944)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.17,
    height: 9.72,
    x: 992.68,
    y: 816.34,
    className: "mobilityStations_before_svg__cls-43",
    rx: 4.02
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1108.37,
    x2: 1114.62,
    y1: 613.46,
    y2: 593.41,
    fill: "#f84c34",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.85 616.36l-8.09-3.71 3.39-16c.7-3.29 3.07-5.12 5.3-4.1 2.24 1 3.48 4.52 2.78 7.81z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1075.44,
    x2: 1064.34,
    y1: 664.3,
    y2: 674.44,
    fill: "#46bea9",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.87 661.45l3.39 7.8-12.35 8.46c-2.54 1.74-5.36 1.4-6.3-.75-.93-2.16.37-5.31 2.91-7.06z",
    className: "mobilityStations_before_svg__cls-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Fahrradstellplatz2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1076.54 860.62a10.14 10.14 0 01-7-3.16 8.26 8.26 0 01-2.21-6 107.5 107.5 0 017.84-33.6 97.48 97.48 0 0143.71-49.44c18-9.87 35.85-14.87 53-14.87a76.45 76.45 0 0131.46 6.52c31.49 14.09 47.18 59.28 42.09 92.65-.66 4.31-4.78 7.56-9.59 7.56a9.26 9.26 0 01-1.28-.08 9.81 9.81 0 01-6.69-3.72 8.08 8.08 0 01-1.62-6.17c4.09-26.76-7.84-63.94-31.48-74.52a55.56 55.56 0 00-22.79-4.7c-17 0-32.8 6.71-43.08 12.34-38.79 21.24-42 64-42.23 68.81s-4.48 8.38-9.67 8.38z",
    className: "mobilityStations_before_svg__cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.84 755.06a75.09 75.09 0 0130.85 6.39c30.13 13.48 46.41 57 41.21 91-.55 3.65-4.07 6.29-8.09 6.29a10.32 10.32 0 01-1.11-.06c-4.47-.54-7.61-4.21-7-8.18 4.25-27.87-8.47-65.43-32.36-76.12a56.93 56.93 0 00-23.4-4.83c-17.6 0-33.94 7.12-43.8 12.52-39.51 21.64-42.77 65.17-43 70.06-.2 3.9-3.82 7-8.17 7h-.36c-4.51-.18-8-3.57-7.81-7.58a105.67 105.67 0 017.73-33.1 96 96 0 0143-48.69c17.81-9.75 35.64-14.69 52.28-14.69m0-3c-17.4 0-35.47 5.07-53.72 15.06a98.92 98.92 0 00-44.38 50.19 109.26 109.26 0 00-8 34.08 9.72 9.72 0 002.61 7.08 11.56 11.56 0 008.08 3.65h.48c6 0 10.89-4.31 11.16-9.8.24-4.72 3.39-46.73 41.46-67.58 10.12-5.54 25.69-12.15 42.36-12.15a53.9 53.9 0 0122.17 4.57c10.42 4.66 19.35 15.31 25.18 30 5.5 13.89 7.49 29.54 5.44 42.94a9.62 9.62 0 001.9 7.31 11.35 11.35 0 007.71 4.3 12.08 12.08 0 001.47.09c5.53 0 10.29-3.8 11.06-8.84 2.65-17.38-.1-37.38-7.57-54.85-8-18.78-20.58-32.77-35.38-39.39a78.12 78.12 0 00-32.08-6.65z",
    className: "mobilityStations_before_svg__cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Fahrrad2-2",
    "data-name": "Fahrrad2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.82,
    height: 7.88,
    x: 1018.19,
    y: 858.98,
    className: "mobilityStations_before_svg__cls-43",
    rx: 3.26
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1006.86 899.63 1002.42 895.72 1027.42 862.93 1033.4 862.87 1006.86 899.63",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "878.12 900.58 827.74 851.32 833.17 846.3 883.55 895.55 878.12 900.58",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1003.15,
    cy: 902.54,
    r: 22.64,
    className: "mobilityStations_before_svg__cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.71 896.2c1.59 6.51-.73 29.35-21.37 29-10.38-.18-132.23-8.51-128.24-29 2.82-14.49 85.32-16.3 128.24-16.3 0 0 17.38 0 21.37 16.3z",
    className: "mobilityStations_before_svg__cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.78 970.89a75 75 0 1175-75 75.12 75.12 0 01-75 75zm0-142.92a67.88 67.88 0 1067.87 67.88A68 68 0 00882.78 828z",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1153.15 894.93 1123.42 831.06 1130.28 828.28 1160.01 892.15 1153.15 894.93",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.7 977.45a81.6 81.6 0 1157.71-23.9 81.06 81.06 0 01-57.71 23.9zm0-156.14a74.53 74.53 0 1074.53 74.53 74.61 74.61 0 00-74.53-74.53zM1157.3 977.45a81.6 81.6 0 1157.7-23.9 81.09 81.09 0 01-57.7 23.9zm0-156.14a74.53 74.53 0 1074.52 74.53 74.62 74.62 0 00-74.52-74.53z",
    className: "mobilityStations_before_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.73 809a89.47 89.47 0 00-64.48 3.84l-6.14-15.1a3.53 3.53 0 00-.82-3.47 3.59 3.59 0 00-.86-.66l-3.74-9.22a3.57 3.57 0 00-.1-2.39L1096 751.4a3.67 3.67 0 00-4.52-2.18 3.54 3.54 0 00-2.1 4.69L1100.1 780l-128 4.77-7.87-27.77a3.67 3.67 0 00-4.24-2.68 3.54 3.54 0 00-2.63 4.42l8.2 28.95-28.29 35.84A89.2 89.2 0 00819 831.1a90 90 0 00-26.24 63.69 4.54 4.54 0 004 4.56 4.43 4.43 0 004.85-4.41c0-44.9 49.36-15 93.91-15l-15.81 16.46a3.54 3.54 0 00.29 4.6 3.65 3.65 0 002.49 1.1l115.09 5.79h1.03l.24-.07h.11l.24-.09.1-.05.24-.13h.08l.26-.17a3 3 0 00.27-.23L1110 802.27l5.29 13a90.51 90.51 0 00-47.52 79.61 4.54 4.54 0 004 4.56 4.43 4.43 0 004.85-4.42c0-44.89 36.24-81.42 80.79-81.42a80.09 80.09 0 0124.68 3.87 4.44 4.44 0 005.69-3.26 4.53 4.53 0 00-3.05-5.21zm-247.59 26.08a81.53 81.53 0 0126.08 59.86 4.42 4.42 0 003.4 4.3l-77.07-3.87zm31.11 64.24a4.43 4.43 0 003.84-4.38 90 90 0 00-26.25-63.84c-1-1-2.09-2.05-3.16-3l25.06-31.75 25.41 104.26zm31.46-1.75L973.93 791.8l129.89-4.8 3.36 8.26z",
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.3,
    cy: 895.84,
    r: 7.06,
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.93 970.06a75 75 0 1175-75 75.12 75.12 0 01-75 75zm0-142.91A67.88 67.88 0 101225.8 895a68 68 0 00-67.87-67.85z",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.75 758.76a6.73 6.73 0 01-3.57-3.34c-1.13-2.49-.58-5.34-.13-7.7.37-1.91 1.45-7.55 5.49-11 2.27-2 4.4-2.31 6.63-2.67a17.11 17.11 0 0111.49 1.84c4.66 2.62 5.11 5.76 10.05 7.44a18.34 18.34 0 004.88.75c6.34.52 9.95-1 17.09-.33 4 .36 5.22 1 5.87 2.34 1.13 2.26.3 5.84-.89 8-2.21 4.07-6.34 4.68-10.72 5.19-7.4.85-11.18.75-21.82 1.38-3.23.2-3.59.28-7 .46-6.12.3-11.79.36-17.37-2.36z",
    className: "mobilityStations_before_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104 692.33c.45-.45-1.84 2.79-2.7 5.85L1087.1 747l-37.81 29.14c-2.57 1.85-5 2.14-3.15 4.72 1.13 1.57 1.06 1.53 2.84 1.53a5.71 5.71 0 003.35-1.08l36.88-26.46 5 11.76 7.33-3.12-7-16.43 13.46-47.65c.8-3.05-6.29-4.86-4-7.08z",
    className: "mobilityStations_before_svg__cls-44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1003.15,
    cy: 902.91,
    r: 7.06,
    fill: "#857d7a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.36
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.24,
    height: 5.8,
    x: 975.7,
    y: 917.21,
    className: "mobilityStations_before_svg__cls-44",
    transform: "rotate(-64.16 994.885 920.124)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.43,
    height: 10.51,
    x: 972.91,
    y: 933.52,
    className: "mobilityStations_before_svg__cls-43",
    rx: 4.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1097.88,
    x2: 1104.64,
    y1: 714.34,
    y2: 692.68,
    className: "mobilityStations_before_svg__cls-53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.89 717.47l-8.74-4 3.66-17.25c.75-3.55 3.32-5.53 5.73-4.42 2.41 1.11 3.76 4.88 3 8.43z",
    className: "mobilityStations_before_svg__cls-54"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1061.29,
    x2: 1049.29,
    y1: 768.34,
    y2: 779.3,
    className: "mobilityStations_before_svg__cls-53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.67 765.26l3.67 8.43-13.34 9.14c-2.74 1.88-5.79 1.52-6.8-.81-1-2.33.39-5.74 3.14-7.62z",
    className: "mobilityStations_before_svg__cls-54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Fahrradstellplatz1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1070.68 978.85a10.09 10.09 0 01-7-3.16 8.27 8.27 0 01-2.22-6 107.77 107.77 0 017.84-33.59 97.52 97.52 0 0143.7-49.44c18-9.87 35.85-14.87 53-14.87a76.7 76.7 0 0131.47 6.52c31.48 14.09 47.18 59.28 42.08 92.65-.66 4.31-4.78 7.56-9.58 7.56a10.86 10.86 0 01-1.28-.07 9.93 9.93 0 01-6.7-3.72 8.15 8.15 0 01-1.61-6.18c4.08-26.76-7.84-63.94-31.49-74.52a55.54 55.54 0 00-22.78-4.69c-17 0-32.81 6.7-43.08 12.33-38.79 21.24-42 64-42.24 68.82s-4.48 8.37-9.66 8.37z",
    className: "mobilityStations_before_svg__cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166 873.29a75.06 75.06 0 0130.85 6.39c30.13 13.48 46.41 57 41.22 91.05-.56 3.65-4.08 6.29-8.1 6.29a10.46 10.46 0 01-1.11-.06c-4.47-.54-7.61-4.2-7-8.18 4.26-27.87-8.46-65.43-32.36-76.12a56.87 56.87 0 00-23.39-4.82c-17.61 0-33.95 7.11-43.8 12.51-39.51 21.64-42.78 65.17-43 70.06-.19 3.9-3.81 7-8.16 7h-.37c-4.51-.18-8-3.57-7.81-7.58a106.28 106.28 0 017.73-33.1 96 96 0 0143-48.69c17.8-9.75 35.63-14.69 52.27-14.69m0-3c-17.4 0-35.47 5.07-53.71 15.06a99 99 0 00-44.39 50.19 109.56 109.56 0 00-8 34.08 9.77 9.77 0 002.61 7.08 11.58 11.58 0 008.08 3.65h.49c6 0 10.88-4.31 11.16-9.8.23-4.72 3.38-46.73 41.46-67.58 10.12-5.54 25.68-12.14 42.36-12.14a54 54 0 0122.17 4.56c10.41 4.66 19.35 15.31 25.17 30 5.51 13.89 7.49 29.54 5.44 43a9.64 9.64 0 001.9 7.3 11.4 11.4 0 007.71 4.3 12.08 12.08 0 001.47.09c5.54 0 10.29-3.8 11.06-8.83 2.66-17.39-.1-37.39-7.56-54.86-8-18.78-20.59-32.77-35.39-39.39a78.08 78.08 0 00-32.08-6.65z",
    className: "mobilityStations_before_svg__cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Lastenr\\xE4der"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.58 215c0-19.88-16.44-36-36.73-36s-36.74 16.12-36.74 36V408.14h73.47V216.62c-.01-.53 0-1.07 0-1.62z",
    className: "mobilityStations_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 0.67,
    x: 288.84,
    y: 217.2,
    className: "mobilityStations_before_svg__cls-55",
    rx: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 0.67,
    x: 296.76,
    y: 222.66,
    className: "mobilityStations_before_svg__cls-55",
    rx: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8 222.67a.32.32 0 01-.33-.34v-1.82l-1.73-.08a.33.33 0 01-.32-.34.33.33 0 01.35-.32l2.06.09a.33.33 0 01.32.34v2.14a.33.33 0 01-.35.33zM291.94 220.44l-2.06-.09a.34.34 0 01-.32-.34v-2.15a.33.33 0 01.34-.32.34.34 0 01.34.33v1.83l1.73.07a.33.33 0 01.32.35.32.32 0 01-.35.32z",
    className: "mobilityStations_before_svg__cls-56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.38,
    height: 0.66,
    x: 292.72,
    y: 219.78,
    className: "mobilityStations_before_svg__cls-57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.38,
    height: 0.66,
    x: 294.63,
    y: 219.78,
    className: "mobilityStations_before_svg__cls-57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.59,
    height: 15.72,
    x: 288.02,
    y: 204.42,
    fill: "#fff",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.77,
    height: 18.42,
    x: 292.97,
    y: 210.81,
    fill: "#455064",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.34,
    rx: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.58,
    height: 1.64,
    x: 292.23,
    y: 208.8,
    className: "mobilityStations_before_svg__cls-60"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.58,
    height: 1.64,
    x: 294.96,
    y: 208.8,
    className: "mobilityStations_before_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.34,
    d: "M295 210.11h-2.39a.69.69 0 00-.69.69v9.58a.41.41 0 00.41.41h0a.41.41 0 00.42-.41v-9.56a2.73 2.73 0 012.11-.07v9.63a.42.42 0 00.84 0v-9.58a.7.7 0 00-.7-.69z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.49,
    height: 3.03,
    x: 291.85,
    y: 218.63,
    className: "mobilityStations_before_svg__cls-55",
    rx: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.49,
    height: 3.03,
    x: 295.53,
    y: 218.63,
    className: "mobilityStations_before_svg__cls-55",
    rx: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.72 208.46a.3.3 0 00-.23-.09 2.9 2.9 0 01-.76-.24l-.41-.18v-.41h-1v.46l-.41.18a2.9 2.9 0 01-.76.24.3.3 0 00-.23.09.38.38 0 00.13.5c.1.06.2 0 .56 0l.35-.08a4.3 4.3 0 01.68-.1h.36a4.25 4.25 0 01.69.1l.34.08c.37.08.47.1.57 0a.31.31 0 00.16-.21.35.35 0 00-.04-.34z",
    className: "mobilityStations_before_svg__cls-62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    d: "M293.12 205.71h1.42v1.77a.18.18 0 01-.18.18h-1.06a.18.18 0 01-.18-.18v-1.77h0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.44,
    height: 1.49,
    x: 292.6,
    y: 204.28,
    className: "mobilityStations_before_svg__cls-62",
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.22,
    height: 1.2,
    x: 292.71,
    y: 204.42,
    fill: "#aec2dd",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e50",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    d: "M293.81 201.64h0a.45.45 0 01.45.45v2.27h0-.91 0v-2.27a.45.45 0 01.45-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.9 201.64h-2.43a.37.37 0 110-.73h2.43a.37.37 0 110 .73z",
    className: "mobilityStations_before_svg__cls-66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 201.26a8.14 8.14 0 001.77 0c.73-.08 1.12-.23 1.43 0s.22.55.62.8a1.34 1.34 0 00.51.18 3.19 3.19 0 001.26 0",
    className: "mobilityStations_before_svg__cls-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.79 201.64h2.43a.37.37 0 100-.73h-2.43a.37.37 0 100 .73z",
    className: "mobilityStations_before_svg__cls-66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.68 201.26a8.13 8.13 0 01-1.77 0c-.73-.08-1.13-.23-1.44 0s-.22.55-.61.8a1.39 1.39 0 01-.52.18 3.14 3.14 0 01-1.25 0",
    className: "mobilityStations_before_svg__cls-67"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.72,
    x2: 289.13,
    y1: 220.43,
    y2: 229.01,
    fill: "#cc4058",
    stroke: "#2c3d4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.38,
    height: 3.74,
    x: 306.69,
    y: 425.22,
    className: "mobilityStations_before_svg__cls-69",
    rx: 1.87
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.38,
    height: 3.74,
    x: 349.99,
    y: 455.51,
    className: "mobilityStations_before_svg__cls-69",
    rx: 1.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.63 455.59a1.85 1.85 0 01-1.82-1.88l.19-10.11-9.43-.42a1.85 1.85 0 01-1.77-1.93 1.88 1.88 0 011.93-1.77l11.23.5a1.85 1.85 0 011.77 1.88l-.21 11.91a1.84 1.84 0 01-1.89 1.82z",
    className: "mobilityStations_before_svg__cls-70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.62 443.22h-.09l-11.23-.49a1.86 1.86 0 01-1.77-1.88l.21-11.92a1.86 1.86 0 011.85-1.82 1.85 1.85 0 011.81 1.89l-.17 10.11 9.43.42a1.85 1.85 0 01-.08 3.7z",
    className: "mobilityStations_before_svg__cls-71"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 3.63,
    x: 327.91,
    y: 439.55,
    className: "mobilityStations_before_svg__cls-57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 3.63,
    x: 338.34,
    y: 439.55,
    className: "mobilityStations_before_svg__cls-57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.3,
    height: 87.2,
    x: 302.21,
    y: 354.37,
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.67,
    height: 102.16,
    x: 329.29,
    y: 389.79,
    className: "mobilityStations_before_svg__cls-72",
    rx: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.19,
    height: 9.08,
    x: 325.21,
    y: 378.65,
    className: "mobilityStations_before_svg__cls-70"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.19,
    height: 9.08,
    x: 340.16,
    y: 378.65,
    className: "mobilityStations_before_svg__cls-70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.46 385.92h-13a3.81 3.81 0 00-3.8 3.81v53.16a2.29 2.29 0 002.28 2.29 2.3 2.3 0 002.29-2.29v-53.06a14.79 14.79 0 0111.51-.34v53.4a2.29 2.29 0 104.57 0v-53.16a3.81 3.81 0 00-3.85-3.81z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 16.82,
    x: 323.13,
    y: 433.16,
    className: "mobilityStations_before_svg__cls-69",
    rx: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 16.82,
    x: 343.26,
    y: 433.16,
    className: "mobilityStations_before_svg__cls-69",
    rx: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e50",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M344.27 376.78a1.81 1.81 0 00-1.26-.53 15 15 0 01-4.13-1.29c-.26-.11-1.39-.58-2.25-1v-2.29h-5.38v2.29c-.87.44-2 .91-2.26 1a15 15 0 01-4.13 1.29 1.48 1.48 0 00-1.46 2.11 2 2 0 00.9 1.2c.56.31 1.08.18 3.08-.26l1.88-.41a23.65 23.65 0 013.75-.59h1.86a23.65 23.65 0 013.75.59l1.87.41c2 .44 2.53.57 3.08.26a2 2 0 00.91-1.2 1.88 1.88 0 00-.21-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07 361.53h7.76v9.82a1 1 0 01-1 1h-5.77a1 1 0 01-1-1v-9.82h.01z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.34,
    height: 8.24,
    x: 327.24,
    y: 353.57,
    className: "mobilityStations_before_svg__cls-74",
    rx: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.13,
    height: 6.64,
    x: 327.85,
    y: 354.37,
    className: "mobilityStations_before_svg__cls-75",
    rx: 2.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.88 338.95a2.49 2.49 0 012.49 2.49V354h-5v-12.6a2.49 2.49 0 012.51-2.45z",
    className: "mobilityStations_before_svg__cls-76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.58 339H288.3a2 2 0 010-4.08h13.28a2 2 0 010 4.08z",
    className: "mobilityStations_before_svg__cls-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.21 336.81a42.15 42.15 0 009.67.12c4-.43 6.16-1.27 7.85.11 1.51 1.24 1.19 3 3.34 4.46a7.49 7.49 0 002.82 1 17.52 17.52 0 006.85.06",
    className: "mobilityStations_before_svg__cls-78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.55 339h13.28a2 2 0 000-4.08h-13.28a2 2 0 000 4.08z",
    className: "mobilityStations_before_svg__cls-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92 336.81a42.15 42.15 0 01-9.67.12c-4-.43-6.16-1.27-7.85.11-1.51 1.24-1.19 3-3.34 4.46a7.49 7.49 0 01-2.82 1 17.52 17.52 0 01-6.85.06",
    className: "mobilityStations_before_svg__cls-78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.91,
    x2: 308.27,
    y1: 443.18,
    y2: 490.73,
    fill: "#cc4058",
    stroke: "#2c3d4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.36
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.38,
    height: 3.74,
    x: 190.62,
    y: 425.15,
    className: "mobilityStations_before_svg__cls-69",
    rx: 1.87
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.38,
    height: 3.74,
    x: 233.91,
    y: 455.44,
    className: "mobilityStations_before_svg__cls-69",
    rx: 1.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.56 455.53a1.84 1.84 0 01-1.81-1.88l.17-10.12-9.43-.41a1.85 1.85 0 01.17-3.7l11.23.5a1.85 1.85 0 011.77 1.88l-.21 11.91a1.86 1.86 0 01-1.89 1.82zM207.54 443.15h-.08l-11.23-.5a1.84 1.84 0 01-1.77-1.88l.21-11.91a1.85 1.85 0 011.85-1.82 1.86 1.86 0 011.82 1.88l-.15 10.08 9.43.42a1.85 1.85 0 01-.08 3.7z",
    className: "mobilityStations_before_svg__cls-71"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 3.63,
    x: 211.83,
    y: 439.48,
    className: "mobilityStations_before_svg__cls-57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 3.63,
    x: 222.26,
    y: 439.48,
    className: "mobilityStations_before_svg__cls-57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.67,
    height: 102.16,
    x: 249.84,
    y: 389.73,
    className: "mobilityStations_before_svg__cls-72",
    rx: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.67,
    height: 102.16,
    x: 177.1,
    y: 389.73,
    className: "mobilityStations_before_svg__cls-72",
    rx: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.19,
    height: 9.08,
    x: 209.14,
    y: 378.59,
    className: "mobilityStations_before_svg__cls-80"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.19,
    height: 9.08,
    x: 224.08,
    y: 378.59,
    className: "mobilityStations_before_svg__cls-80"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea384e",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 1.85,
    d: "M224.39 385.86h-13a3.8 3.8 0 00-3.81 3.81v53.16a2.28 2.28 0 002.28 2.28h0a2.28 2.28 0 002.29-2.28v-53.06a14.81 14.81 0 0111.52-.34v53.4a2.29 2.29 0 004.57 0v-53.16a3.81 3.81 0 00-3.85-3.81z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 16.82,
    x: 207.06,
    y: 433.1,
    className: "mobilityStations_before_svg__cls-69",
    rx: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 16.82,
    x: 227.19,
    y: 433.1,
    className: "mobilityStations_before_svg__cls-69",
    rx: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.2 376.71a1.82 1.82 0 00-1.26-.52 15.58 15.58 0 01-4.13-1.29c-.27-.11-1.39-.59-2.26-1v-2.28h-5.38v2.28c-.87.44-2 .92-2.25 1a15.76 15.76 0 01-4.14 1.29 1.82 1.82 0 00-1.26.52 1.89 1.89 0 00-.2 1.59 2 2 0 00.91 1.2c.55.31 1.08.18 3.07-.27l1.88-.41a24.79 24.79 0 013.75-.58h1.86a24.79 24.79 0 013.75.58l1.88.41c2 .45 2.52.58 3.07.27a2 2 0 00.91-1.2 1.89 1.89 0 00-.2-1.59z",
    className: "mobilityStations_before_svg__cls-74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 361.46h7.76v9.82a1 1 0 01-1 1H215a1 1 0 01-1-1v-9.82z",
    className: "mobilityStations_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.34,
    height: 8.24,
    x: 211.16,
    y: 353.51,
    className: "mobilityStations_before_svg__cls-74",
    rx: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.13,
    height: 6.64,
    x: 211.77,
    y: 354.31,
    className: "mobilityStations_before_svg__cls-75",
    rx: 2.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.81 338.88a2.49 2.49 0 012.49 2.49V354h-5v-12.6a2.49 2.49 0 012.49-2.49z",
    className: "mobilityStations_before_svg__cls-76"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.3,
    height: 87.2,
    x: 186.13,
    y: 374.05,
    className: "mobilityStations_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 338.88h-13.27a2 2 0 110-4.07h13.27a2 2 0 110 4.07z",
    className: "mobilityStations_before_svg__cls-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.13 336.74a41.58 41.58 0 009.67.12c4-.43 6.16-1.27 7.86.12 1.5 1.23 1.18 3 3.34 4.45a7.45 7.45 0 002.81 1 17.57 17.57 0 006.86.06",
    className: "mobilityStations_before_svg__cls-78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.47 338.88h13.28a2 2 0 100-4.07h-13.28a2 2 0 000 4.07z",
    className: "mobilityStations_before_svg__cls-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84 336.74a41.58 41.58 0 01-9.67.12c-4-.43-6.16-1.27-7.85.12-1.51 1.23-1.18 3-3.34 4.45a7.52 7.52 0 01-2.81 1 17.57 17.57 0 01-6.86.06",
    className: "mobilityStations_before_svg__cls-78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.48 239.76h6.95v7h-6.95v-7m-.66-.66v8.27h8.27v-8.27z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.21,
    height: 3.21,
    x: 283.35,
    y: 241.62,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.27 239.76h6.94v7h-6.94v-7m-.66-.66v8.27h8.26v-8.27z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.21,
    height: 3.21,
    x: 301.18,
    y: 241.62,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.48 257.55h6.95v6.95h-6.95v-6.95m-.66-.66v8.27h8.27v-8.27z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 3.2,
    x: 283.35,
    y: 259.42,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.27 257.55h7v6.95h-7v-6.95m-.66-.66v8.27h8.27v-8.27z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 3.2,
    x: 301.14,
    y: 259.42,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.75 248H298v8.2h-8.2V248m-.66-.66v9.52h9.52v-9.52z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.21,
    height: 3.21,
    x: 292.27,
    y: 250.53,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 3.2,
    x: 292.25,
    y: 256.89,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.21,
    height: 3.21,
    x: 292.27,
    y: 244.16,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.21,
    height: 3.21,
    x: 285.89,
    y: 250.54,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 3.2,
    x: 298.64,
    y: 250.53,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 3.2,
    x: 283.35,
    y: 253.73,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.21,
    height: 3.21,
    x: 283.35,
    y: 247.32,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 3.2,
    x: 301.84,
    y: 253.73,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 3.2,
    x: 301.84,
    y: 247.33,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 3.2,
    x: 289.05,
    y: 260.1,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 3.2,
    x: 295.45,
    y: 260.1,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.21,
    height: 3.21,
    x: 289.06,
    y: 240.95,
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.21,
    height: 3.21,
    x: 295.48,
    y: 240.95,
    className: "mobilityStations_before_svg__cls-42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Handy"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707384",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.34,
    d: "M214.47 985.19L61.28 909.9a39.88 39.88 0 01-18.19-53.37l155.63-316.94a39.84 39.84 0 0153.34-18.2l153.19 75.29a39.88 39.88 0 0118.2 53.37L267.81 967a39.84 39.84 0 01-53.34 18.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46bea9",
    d: "M224.11 927.94l-123.43-60.66a32.13 32.13 0 01-14.66-43l125.4-255.37a32.11 32.11 0 0143-14.67l123.43 60.67a32.14 32.14 0 0114.66 43L267.09 913.28a32.1 32.1 0 01-42.98 14.66z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.01,
    cy: 920.21,
    className: "mobilityStations_before_svg__cls-84",
    rx: 14.62,
    ry: 14.63
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.16 589l-29.88-14.69a5.41 5.41 0 01-2.47-7.25 5.41 5.41 0 017.24-2.47l29.88 14.69a5.42 5.42 0 012.48 7.25 5.42 5.42 0 01-7.25 2.47z",
    className: "mobilityStations_before_svg__cls-84"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.87,
    cy: 561.73,
    r: 5.52,
    className: "mobilityStations_before_svg__cls-84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#468cbe",
    d: "M305.11 835.86l-181-89L212.92 566c7-14.29 25.69-19.51 41.69-11.64l123.06 60.48c16 7.86 23.29 25.83 16.27 40.13z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 45.96,
    transform: "rotate(25.8 -1715.6 670.863)"
  }, "\r\n      Buchen\r\n     "), /*#__PURE__*/React.createElement("path", {
    d: "M233.4 612.27l31.6 15.52-15.53 31.59-31.59-15.52 15.53-31.59m-1.53-4.48l-18.48 37.59 37.6 18.48 18.47-37.59-37.59-18.48z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 233.33,
    y: 627.66,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 241.486 635.878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.29 652l31.6 15.53-15.53 31.59-31.59-15.52 15.52-31.6m-1.52-4.47l-18.47 37.61 37.58 18.48L350.36 666l-37.59-18.48z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 314.4,
    y: 667.5,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 322.554 675.715)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.64 693.16l31.59 15.53-15.52 31.59-31.59-15.52 15.52-31.6m-1.52-4.47l-18.48 37.59 37.59 18.48 18.48-37.59-37.59-18.48z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 16.23,
    x: 193.56,
    y: 708.61,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 201.684 716.802)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.54 732.92l31.59 15.53L290.6 780 259 764.51l15.53-31.59m-1.53-4.47L254.54 766l37.59 18.47 18.47-37.59-37.6-18.43z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 16.23,
    x: 274.45,
    y: 748.37,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 282.58 756.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.51 668.33l37.31 18.34L271.49 724l-37.31-18.34 18.33-37.31m-1.51-4.49l-21.28 43.31L273 728.45l21.29-43.31L251 663.86z",
    className: "mobilityStations_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 253.97,
    y: 688.11,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 262.115 696.339)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 16.23,
    x: 239.68,
    y: 716.98,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 247.803 725.196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 268.21,
    y: 659.12,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 276.348 667.341)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 224.95,
    y: 673.86,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 233.09 682.089)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 16.23,
    x: 282.96,
    y: 702.33,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 291.103 710.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 16.23,
    x: 206.28,
    y: 682.71,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 214.419 690.918)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 220.59,
    y: 653.58,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 228.735 661.788)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 16.23,
    x: 290.37,
    y: 724.06,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 298.515 732.274)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 16.23,
    x: 304.69,
    y: 694.92,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 312.826 703.122)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 16.23,
    x: 217.95,
    y: 724.39,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 226.08 732.603)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 16.23,
    x: 247.09,
    y: 738.71,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 255.21 746.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 260.79,
    y: 637.35,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 268.931 645.575)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 289.98,
    y: 651.7,
    className: "mobilityStations_before_svg__cls-42",
    transform: "rotate(26.17 298.136 659.919)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Busch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.27 296.79h-1.81c-10.66 0-19.34-5.57-19.34-12.41 0-5.55 5.66-10.34 13.74-11.89a9.58 9.58 0 01-3.22-6.87c0-5.56 5.62-10.35 13.81-11.89a7.94 7.94 0 01-.33-2.24c0-6 6.54-11.08 15.68-12.18.62-6.49 9-11.65 19.3-11.65a30 30 0 015.14.44c3.6-3.35 9.5-5.33 15.89-5.33a27.81 27.81 0 0110.22 1.86c3.3-2.92 8.52-4.8 14.17-5.07 3.59-3.45 9.56-5.49 16.06-5.49 10.34 0 18.81 5.23 19.32 11.79 6.48 1.05 11.71 4.23 13.69 8.32 9.2 0 16.91 4.09 18.78 9.79 9.11.16 16.65 4.27 18.39 10 7.68 1.75 12.8 6.39 12.8 11.68 0 2.9-1.5 5.61-4.26 7.8 6.26 2.14 10.19 6.29 10.19 11 0 5.66-6 10.59-14.46 12h-.08l-172.79.39a7.85 7.85 0 01-.89-.05z",
    className: "mobilityStations_before_svg__cls-87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.58 215c10.13 0 18.34 5.11 18.34 11.41v.25c6.91.89 12.38 4.22 14 8.47h.54c9.24 0 16.86 4.26 18.13 9.79h.21c9.25 0 16.88 4.27 18.13 9.81 7.32 1.5 12.61 5.78 12.61 10.84 0 3.21-2.13 6.1-5.55 8.17 6.73 1.69 11.48 5.79 11.48 10.59 0 5.28-5.78 9.72-13.62 11l-172.71.4h-2.7c-10.13 0-18.34-5.11-18.34-11.41 0-5.62 6.52-10.28 15.1-11.23-2.84-2-4.58-4.64-4.58-7.53 0-5.41 6-9.92 14.16-11.1a7.44 7.44 0 01-.68-3c0-5.74 6.8-10.47 15.66-11.28a.68.68 0 010-.14c0-6.3 8.21-11.41 18.34-11.41a29.08 29.08 0 015.46.51c3.24-3.24 9-5.4 15.57-5.4a26.49 26.49 0 0110.43 2c3.08-3 8.34-5 14.39-5.26 3.22-3.28 9-5.47 15.63-5.47m0-2c-6.59 0-12.68 2.05-16.47 5.51-5.56.33-10.53 2.09-14 4.9a29.2 29.2 0 00-10-1.71c-6.43 0-12.39 2-16.2 5.26a30.77 30.77 0 00-4.83-.37c-10.55 0-19 5-20.19 11.76-9.24 1.36-15.79 6.69-15.79 13.07a9.12 9.12 0 00.13 1.47c-8.12 1.83-13.61 6.84-13.61 12.66a10.08 10.08 0 002.38 6.3c-7.63 2-12.84 6.85-12.84 12.48 0 7.52 8.94 13.41 20.34 13.41h2.81l172.62-.4h.23c9-1.49 15.3-6.83 15.3-13 0-4.69-3.54-8.89-9.29-11.3a10.43 10.43 0 003.36-7.46c0-5.64-5.19-10.57-13-12.53-2.11-5.67-9.52-9.75-18.46-10.1-2.31-5.62-9.86-9.6-18.87-9.8-2.22-4-7.15-7-13.4-8.19-1.08-6.8-9.57-11.93-20.22-11.93z",
    className: "mobilityStations_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "mobilityStations_before_svg__cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.36 289.64c0-5.62 6.51-10.28 15.09-11.23-2.84-2-4.58-4.64-4.58-7.53 0-5.41 6.05-9.92 14.16-11.1a7.43 7.43 0 01-.67-3c0-5.74 6.8-10.47 15.65-11.28v-.14c0-6.3 8.21-11.41 18.33-11.41a29.08 29.08 0 015.46.51c3.24-3.24 9-5.4 15.58-5.4a26.48 26.48 0 0110.42 2c3.08-3 8.34-5 14.39-5.26 3.23-3.28 9-5.47 15.63-5.47a27.66 27.66 0 018.43 1.28c-2.92-3.88-9.24-6.58-16.59-6.58-6.63 0-12.41 2.19-15.63 5.47-6.06.22-11.32 2.26-14.39 5.26a26.56 26.56 0 00-10.43-2c-6.58 0-12.34 2.16-15.57 5.4a29.19 29.19 0 00-5.47-.51c-10.12 0-18.33 5.11-18.33 11.41v.14c-8.85.81-15.65 5.54-15.65 11.28a7.43 7.43 0 00.67 3c-8.11 1.18-14.16 5.69-14.16 11.1 0 2.89 1.74 5.52 4.58 7.53-8.58.95-15.09 5.61-15.09 11.23 0 4.41 4 8.23 9.91 10.13a8 8 0 01-1.74-4.83z",
    className: "mobilityStations_before_svg__cls-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Busch-2",
    "data-name": "Busch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-42.49 317.83h-1.8c-10.67 0-19.34-5.57-19.34-12.42 0-5.55 5.65-10.33 13.73-11.88a9.57 9.57 0 01-3.21-6.87c0-5.57 5.61-10.35 13.8-11.9a8.19 8.19 0 01-.32-2.24c0-6 6.54-11.07 15.67-12.18.62-6.49 9-11.65 19.3-11.65a30 30 0 015.14.44c3.61-3.34 9.5-5.33 15.9-5.33a27.79 27.79 0 0110.21 1.86c3.3-2.92 8.52-4.79 14.17-5.07 3.59-3.44 9.56-5.48 16.06-5.48 10.34 0 18.81 5.23 19.31 11.79 6.49 1 11.72 4.22 13.7 8.32 9.2 0 16.91 4.09 18.78 9.79 9.11.16 16.65 4.26 18.39 10 7.68 1.76 12.8 6.4 12.8 11.69 0 2.89-1.5 5.61-4.26 7.8 6.25 2.13 10.19 6.29 10.19 10.95 0 5.66-5.95 10.6-14.46 12h-.08l-172.79.4h-.89z",
    className: "mobilityStations_before_svg__cls-87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.82 236.08c10.13 0 18.34 5.11 18.34 11.41v.24c6.91.9 12.38 4.22 14 8.47h.54c9.24 0 16.86 4.26 18.13 9.79h.21c9.25 0 16.88 4.27 18.13 9.82 7.32 1.5 12.61 5.78 12.61 10.84 0 3.2-2.13 6.1-5.55 8.17 6.73 1.69 11.48 5.79 11.48 10.58 0 5.29-5.79 9.72-13.62 11l-172.71.4h-2.69c-10.13 0-18.34-5.11-18.34-11.42 0-5.61 6.51-10.27 15.09-11.22-2.84-2-4.57-4.64-4.57-7.53 0-5.41 6-9.93 14.15-11.11a7.39 7.39 0 01-.67-3c0-5.73 6.8-10.46 15.65-11.27v-.14c0-6.3 8.21-11.42 18.33-11.42a28.36 28.36 0 015.47.52c3.23-3.24 9-5.41 15.57-5.41a26.66 26.66 0 0110.42 2c3.08-3 8.34-5 14.39-5.26 3.23-3.27 9-5.46 15.63-5.46m0-2c-6.59 0-12.68 2-16.47 5.5-5.56.34-10.53 2.09-14 4.91a29 29 0 00-10-1.72c-6.44 0-12.4 2-16.21 5.27a30.76 30.76 0 00-4.83-.38c-10.55 0-19 5.05-20.19 11.76-9.24 1.36-15.78 6.69-15.78 13.07a9.11 9.11 0 00.12 1.47c-8.12 1.84-13.6 6.85-13.6 12.67a10 10 0 002.32 6.27c-7.64 2-12.84 6.86-12.84 12.48 0 7.52 8.93 13.42 20.34 13.42h2.8l172.62-.4h.32c9-1.49 15.3-6.83 15.3-13 0-4.68-3.55-8.88-9.29-11.3a10.46 10.46 0 003.36-7.45c0-5.64-5.19-10.57-13-12.53-2.11-5.68-9.52-9.75-18.46-10.1-2.31-5.62-9.86-9.6-18.87-9.8-2.22-4-7.15-7-13.4-8.19-1.08-6.8-9.57-11.93-20.22-11.93z",
    className: "mobilityStations_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "mobilityStations_before_svg__cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-54.46 310.68c0-5.61 6.51-10.27 15.09-11.22-2.84-2-4.58-4.64-4.58-7.53 0-5.41 6.05-9.93 14.16-11.11a7.39 7.39 0 01-.67-3c0-5.73 6.8-10.46 15.65-11.27v-.14c0-6.31 8.2-11.42 18.33-11.42a29.07 29.07 0 015.46.52c3.24-3.24 9-5.41 15.57-5.41a26.67 26.67 0 0110.43 2c3.08-3 8.33-5 14.39-5.26 3.22-3.27 9-5.46 15.63-5.46a27.45 27.45 0 018.43 1.28c-2.93-3.89-9.25-6.58-16.6-6.58-6.62 0-12.4 2.19-15.63 5.46-6 .22-11.31 2.26-14.39 5.26a26.66 26.66 0 00-10.42-2C9.8 244.77 4 246.94.81 250.18a28.36 28.36 0 00-5.47-.52c-10.12 0-18.33 5.11-18.33 11.42v.14c-8.85.81-15.65 5.54-15.65 11.28a7.38 7.38 0 00.67 3c-8.11 1.18-14.15 5.7-14.15 11.11 0 2.89 1.73 5.52 4.57 7.53-8.57.95-15.09 5.61-15.09 11.22 0 4.41 4 8.23 9.91 10.13a8 8 0 01-1.73-4.81z",
    className: "mobilityStations_before_svg__cls-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_before_svg__Schild3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.92,
    height: 62.56,
    x: 1038.27,
    y: 267,
    className: "mobilityStations_before_svg__cls-11",
    rx: 13.38
  }), /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_before_svg__cls-12",
    transform: "matrix(1.04 0 0 1 1070.5 305.03)"
  }, "\r\n      P\r\n     "), /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_before_svg__cls-13",
    transform: "matrix(1.04 0 0 1 1046.1 322.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "mobilityStations_before_svg__cls-14"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.61,
    y: 0,
    className: "mobilityStations_before_svg__cls-15"
  }, "arSha"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.78,
    y: 0,
    className: "mobilityStations_before_svg__cls-16"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.75,
    y: 0
  }, "ing"))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilityStationsbefore);
export default __webpack_public_path__ + "static/media/mobilityStations.before.d06bcbe7.svg";
export { ForwardRef as ReactComponent };